import {  GET_CONTACT_COLLECTION } from '../../constants/reducerTypes';

const initialState = {};
const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_COLLECTION:
      return {
        ...state,
        contactdata: action.payload,
      };
    default:
      return state;
  }
};
export default contactReducer;
